/**
 * Every error code the API can return as { error: { code } }. Shared by the API and the web
 * app (browser-safe), so the web app must have a message for each one or it will not compile.
 */
export const ERROR_CODES = [
  'VALIDATION_FAILED',
  'BAD_REQUEST',
  'UNAUTHENTICATED',
  'INVALID_CREDENTIALS',
  'INVALID_CURRENT_PASSWORD',
  'INVALID_API_KEY',
  'INVALID_TOKEN',
  'EMAIL_NOT_VERIFIED',
  'USER_DISABLED',
  'TENANT_SUSPENDED',
  'SIGNUP_DISABLED',
  'WEAK_PASSWORD',
  'CSRF_FAILED',
  'FORBIDDEN',
  'SESSION_REQUIRED',
  'NO_ACTIVE_TENANT',
  'NOT_A_MEMBER',
  'LAST_OWNER',
  'ALREADY_MEMBER',
  'INVITE_EMAIL_MISMATCH',
  'ACCOUNT_EXISTS',
  'NOT_FOUND',
  'RATE_LIMITED',
  'DOMAIN_ALREADY_EXISTS',
  'MAILBOX_ALREADY_EXISTS',
  'DOMAIN_NOT_IN_WORKSPACE',
  'LIMIT_TOO_HIGH',
  'HOST_NOT_ALLOWED',
  'INSECURE_CONNECTION_NOT_ALLOWED',
  'CHECK_IN_PROGRESS',
  'DOMAIN_HAS_MAILBOXES',
  'TEST_EMAIL_FAILED',
  'FILE_REJECTED',
  'IMPORT_ALREADY_STARTED',
  'LEAD_ALREADY_EXISTS',
  'LIST_ALREADY_EXISTS',
  'NOTHING_TO_VERIFY',
  'SUPPRESSION_ALREADY_EXISTS',
  'UNDO_EXPIRED',
  'CAMPAIGN_NOT_EDITABLE',
  'CAMPAIGN_NOT_READY',
  'CONFIRM_REQUIRED',
  'SEND_NOT_UNKNOWN',
  'OAUTH_NOT_CONFIGURED',
  'MAILBOX_LIMIT_REACHED',
  'REPLY_FROM_INBOX_OFF',
  'NOT_DRY_RUN',
  'PLATFORM_ADMIN_REQUIRED',
  'LINK_BLOCKLISTED',
  'TRACKING_DOMAIN_REQUIRED',
  'NO_SEED_INBOXES',
  'SEED_ALREADY_EXISTS',
  'DRY_RUN_ON',
  // Step 15: roles, data scope, act-as, preview
  'ACT_AS_READ_ONLY',
  'ACT_AS_ENDED',
  'PREVIEW_READ_ONLY',
  'ROLE_IN_USE',
  'ROLE_NAME_TAKEN',
  'TEAM_NAME_TAKEN',
  'INVALID_OWNER',
  'MEMBER_DEACTIVATED',
  // Step 16: analytics and reports
  'REPORT_PASSWORD_REQUIRED',
  'REPORT_PASSWORD_WRONG',
  'REPORT_NOT_ALLOWED',
  // Step 17: organisations (Super Admin)
  'ORGANISATION_NOT_ACTIVE',
  'ORGANISATION_NOT_SUSPENDED',
  'STAFF_ACCOUNT',
  'NOT_YOURSELF',
  // Step 17f: Super Admin edits people
  'EMAIL_TAKEN',
  'MEMBER_OF_ORGANISATION',
  'CAMPAIGN_BUSY',
  'INTERNAL',
] as const;

export type ErrorCode = (typeof ERROR_CODES)[number];

export function isErrorCode(value: unknown): value is ErrorCode {
  return typeof value === 'string' && (ERROR_CODES as readonly string[]).includes(value);
}
